import { render, staticRenderFns } from "./ServersRecipeInstall.vue?vue&type=template&id=d025650a"
import script from "./ServersRecipeInstall.vue?vue&type=script&lang=js"
export * from "./ServersRecipeInstall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports